module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/wood-1-68117046eb0c64a354953429e74080b7.svg";